module.exports = __webpack_public_path__ + "img/icon-72.8be7f0fc.png";